import React from 'react';
import { motion } from 'framer-motion';
import { XCircleIcon } from 'lucide-react';
export function WhyItDidntWork() {
  const points = ['Los interrogatorios activan la amígdala cerebral del adolescente, enviándolo directamente al modo de "ataque o huida".', 'Los consejos rápidos ("sal a caminar", "échale ganas") invalidan su dolor químico y le hacen sentir que no lo entiendes.', 'Intentar "arreglarlo" en lugar de acompañarlo crea una jerarquía de poder que el adolescente deprimido rechaza por instinto.', 'El choque cultural entre el hogar y la vida en EE. UU. genera una brecha de comunicación que el lenguaje tradicional no puede llenar.'];
  return <section className="bg-section-alt py-16 md:py-24 px-4" data-id="element-129">
      <div className="max-w-4xl mx-auto" data-id="element-130">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} data-id="element-131">
          <h2 className="font-heading text-3xl md:text-4xl text-navy font-bold mb-10 text-center" data-id="element-132">
            Por qué lo que intentaste hasta ahora falló
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8" data-id="element-133">
            {points.map((point, index) => <motion.div key={index} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: index * 0.1
          }} className="flex items-start p-6 bg-gray-warm rounded-xl" data-id="element-134">
                <XCircleIcon className="w-8 h-8 text-danger-soft flex-shrink-0 mr-4 mt-1" data-id="element-135" />
                <p className="font-body text-charcoal text-lg leading-relaxed" data-id="element-136">
                  {point}
                </p>
              </motion.div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}